const dt2 = new Date().getTime();

const getYear = num => new Date(num).getTime();

const getYearDifference = (date1, date2) => {
  let diff = (date2 - date1) / 1000;
  diff /= 60 * 60 * 24;
  return Math.abs(Math.round(diff / 365.25));
};

const getSkillsYears = arr => {
  return arr.map(skill => {
    const dt1 = getYear(skill.startDate);
    return getYearDifference(dt1, dt2);
  });
};

const getMaxYears = arr => Math.max(...arr);

const creatSkillsYearsObj = (arr, num) => {
  let list = [];
  for (let i = 1; i <= num; i++) {
    const yrObj = { year: i, skills: [] };
    arr.forEach(e => {
      const dt1 = getYear(e.startDate);
      const diff = getYearDifference(dt1, dt2);
      if (e.experience) {
        if (e.experience === i) {
          yrObj.skills.push(e);
        }
      } else {
        if (diff === i) {
          yrObj.skills.push(e);
        }
      }
    });
    list.push(yrObj);
  }
  return list;
};




export {
  getYearDifference,
  getSkillsYears,
  getMaxYears,
  creatSkillsYearsObj
};
